import { Component, Input } from '@angular/core';
import { ChurchInformation } from 'src/app/church';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent {

  @Input() church: ChurchInformation = new ChurchInformation();

  constructor() {
  }
}
